const SIDEBAR_ITEM_COLORS = {
    pressed: "#222958",
    hover: "#1b214b",
    active: "#1e244e",
    activeHover: "#262e69",
};
const ICON_SIZE = 24;
const CAN_BE_FOCUSED = 0;

export { CAN_BE_FOCUSED, ICON_SIZE, SIDEBAR_ITEM_COLORS };
//# sourceMappingURL=constants.js.map
